'use strict';

/**
* @ngdoc service
* @name tcApp.LegacyScopeUtilsService
* @description
* Contains utility functions used by legacy scope modules
*
*/
angular.module('tc.legacyScope')
.factory('LegacyScopeUtilsService', function($timeout, $log, $window, tcConstants) {
	// Sets item validity with a fallback to set via timeout
	// (Form is only defined once the component script has executed)
	var setInputValidity = function($scope, item, validationErrorKeyOrObject, isValid) {
		if (angular.isObject(validationErrorKeyOrObject)) {
			angular.forEach(validationErrorKeyOrObject, function (isValid, validationErrorKey) {
				setInputValidity($scope, item, validationErrorKey, isValid);
			});
			return;
		}
		if ((angular.isDefined($scope.componentForm[$scope.componentHtmlName]))
			&& angular.isDefined($scope.componentForm[$scope.componentHtmlName][item.id])) {
			$scope.componentForm[$scope.componentHtmlName][item.id].$setValidity(validationErrorKeyOrObject, isValid);
		} else {
			$timeout(function setInputValidityOnScriptDone() {
				if ((angular.isDefined($scope.componentForm[$scope.componentHtmlName]))
					&& angular.isDefined($scope.componentForm[$scope.componentHtmlName][item.id])) {
					$scope.componentForm[$scope.componentHtmlName][item.id].$setValidity(validationErrorKeyOrObject, isValid);
					// Assume that this will only be triggered on load
					$scope.componentForm[$scope.componentHtmlName][item.id].$tcInvalidOnLoad = !isValid;
				}
			}, 100);
		}
	};

	// Utility function to return a form item, checking form is defined first
	var getFormItem = function($scope, id) {
		if (angular.isUndefined($scope.componentForm)) return;
		if (angular.isUndefined($scope.componentForm[$scope.componentHtmlName])) return;
		if (angular.isUndefined($scope.componentForm[$scope.componentHtmlName][id])) return;

		return $scope.componentForm[$scope.componentHtmlName][id];
	};

	// Utility function to run another function once the instance of CKEditor is ready
	var runOnEditorReady = function($scope, itemOrId, onReadyFunction, componentName) {
		if (angular.isUndefined(itemOrId) || (itemOrId === '')
			|| (!angular.isFunction(onReadyFunction))) {
			$log.warn('runOnEditorReady: Invalid arguments');
			return;
		}
		var id = '';
		var item = null;
		if (angular.isObject(itemOrId)) {
			item = itemOrId;
		} else {
			id = itemOrId;
		}

		var runOnEditorReadyInterval = null;
		var runOnEditorReadyRetryCount = 0;
		var testEditorReady = function() {
			var editor = $scope['websys_getEditor'](item, id, componentName);
			if ((editor) && (editor.instanceReady)) {
				$scope['websys_clearInterval'](runOnEditorReadyInterval);
				runOnEditorReadyInterval = null;
				runOnEditorReadyRetryCount = 0;
				onReadyFunction(editor);
			} else {
				if (runOnEditorReadyRetryCount >= tcConstants.EDITOR.MAX_RETRIES) {
					$log.warn('runOnEditorReady: Could not find ready instance of editor: ', itemOrId);
					$scope['websys_clearInterval'](runOnEditorReadyInterval);
					runOnEditorReadyInterval = null;
					runOnEditorReadyRetryCount = 0;
				} else {
					runOnEditorReadyRetryCount++;
				}
			}
		};

		runOnEditorReadyInterval = $scope['websys_setInterval'](testEditorReady,
												tcConstants.EDITOR.RETRY_DELAY, onReadyFunction);
		return;
	};

	// Returns the id of the HTML element for an item within a component scope.
	// Used for operations on elements that are not invoked by Angular (e.g. focus)
	var getHtmlIdForItem = function($scope, item) {
		if (!angular.isObject(item)) return;
		
		let itemHtmlId;
		if (item.isSelectItem) {
			itemHtmlId = $scope.componentHtmlName + '-page-' + ($scope.data.listData.pageCount - 1)
					+ '-row-' + item._listRowIndex + '-misc-select';
		} else if (angular.isDefined(item._listRowIndex)) {
			itemHtmlId = ($scope.componentHtmlName + '-row-' + item._listRowIndex + '-item');
			if (typeof item._dynamicColumnIndex === 'number') {
				itemHtmlId += ('-' + item._dynamicColumnIndex);
				// Example: websys_KitchenSink_DynamicColumns_0-row-0-item-8-DynamicColCheckbox
			}
			itemHtmlId += ('-' + item.id.substr(0, item.id.lastIndexOf('z')));
		} else if (item.displayType === 'B') {
			itemHtmlId = $scope.componentHtmlName + '-button-' + item.id;
		} else {
			itemHtmlId = $scope.componentHtmlName + '-item-' + item.id;
		}
		if (item.displayType === 'A') itemHtmlId += '-link';
		if ((item.displayType === 'L') && item.isValueList) itemHtmlId += '-option-0';
		if (item.displayType === 'IP') itemHtmlId += '-icon-0';
		
		return itemHtmlId;
	};

	/// expand the accordion section containing the $scope.viewModel.requiredItemsForButtonBar[item]
	///  internal function only
	var expandSectionForItem = function($scope, viewModelItem, requiredFormItem) {
		// viewModelItem.accordion will be created upon first call
		//  if defined, will be the accordion object, or a null object if not in a collapsible accordion section
		if (angular.isDefined(viewModelItem.accordion)) {
			if (viewModelItem.accordion.headerObject) {
				$scope.$broadcast('tcAccordionHeader:expandAccordion', viewModelItem.accordion.headerObject, requiredFormItem);
			}
			return;
		}

		var itemElementId = getHtmlIdForItem($scope, viewModelItem.item);
		var itemElement = $window.document.getElementById(itemElementId);
		if (!itemElement) {
			$log.warn('expandSectionForItem: Could not find itemElement for: ', itemElementId);
			return;
		}

		var getSectionElement = function(node) {
			if (angular.isUndefined(node)) return null;
			if (angular.isDefined(node.className) && ((' ' + node.className + ' ').indexOf(' componentSection ') !== -1)
			&& (node.id.substring(node.id.lastIndexOf('-')) === '-content')) {
				return node;
			} else {
				return getSectionElement(node.parentNode);
			}
		};

		var accordionHeader;
		var sectionElement = getSectionElement(itemElement.parentNode);
		if (sectionElement) {
			var accordionHeaderId = sectionElement.id.substring(0, sectionElement.id.lastIndexOf('-')) + '-header';
			var accordionHeaderElement = $window.document.getElementById(accordionHeaderId);
			if ((accordionHeaderElement) && (accordionHeaderElement.tagName === 'TC-ACCORDION-HEADER')) {
				accordionHeader = angular.element(accordionHeaderElement);
				$scope.$broadcast('tcAccordionHeader:expandAccordion', accordionHeader, requiredFormItem);
			}
		}
		viewModelItem.accordion = {
			headerObject: accordionHeader
		};
	};

	/// Utility to expand the accordion section containing the item, if the item is required (and empty)
	var expandSectionForRequiredItem = function($scope, dataItem) {
		if (angular.isUndefined($scope.componentForm[$scope.componentHtmlName])) return;
		var itemName = dataItem.id;
		var isValueRequired = false;
		var formItem = getFormItem($scope, itemName);
		if ((angular.isObject(formItem)) && (angular.isObject(formItem.$error))) {
			isValueRequired = (formItem.$error.required || formItem.$error.invalid);
		}
		if (!isValueRequired) return;
		if (angular.isUndefined($scope.viewModel.requiredItemsForButtonBar[itemName])) {
			$scope.viewModel.requiredItemsForButtonBar[itemName] = {'item': dataItem};
		}

		var viewModelItem = $scope.viewModel.requiredItemsForButtonBar[itemName];
		expandSectionForItem($scope, viewModelItem, formItem);
	};

	/// Utility to expand the accordion section containing the item, when called from websysSetForcus
	var expandSectionForFocusedItem = function($scope, dataItem) {
		var itemName = dataItem.id;
		if (angular.isUndefined($scope.viewModel.requiredItemsForButtonBar[itemName])) {
			$scope.viewModel.requiredItemsForButtonBar[itemName] = {'item': dataItem};
		}

		var viewModelItem = $scope.viewModel.requiredItemsForButtonBar[itemName];
		expandSectionForItem($scope, viewModelItem);
	};

	/// Returns whether the item passed is a dynamic column item (collection of dynamic columns)
	var isDynamicColumnCollection = function(item) {
		if (!Array.isArray(item) || !item.length) return false;
		return item.every(dynamicColumnItem => !!dynamicColumnItem.isDynamicColumn);
	};

	return {
		expandSectionForRequiredItem: expandSectionForRequiredItem,
		expandSectionForFocusedItem: expandSectionForFocusedItem,
		getFormItem: getFormItem,
		getHtmlIdForItem: getHtmlIdForItem,
		isDynamicColumnCollection: isDynamicColumnCollection,
		runOnEditorReady: runOnEditorReady,
		setInputValidity: setInputValidity,
	};
});
